<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>


export default {
  name: 'App',
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: PingFang-SC-Medium !important;

}


.main{
  background-image: url(./assets/bg.jpg) ;
  background-size: cover;
  background-position-x: center;
  z-index: 1000;
}

.head-left .logo {

  width: 15.396vw !important;
  height: 1.6vw !important;


}

.head{
  background-color: #1542a0 !important;
   box-shadow: 60px -16px teal !important;
  z-index: 1000 !important;
}
.foot{
  background-color: #1542a6 !important;
}

.main-left{
  background-color: transparent !important;
}

.main-left-item{
  color: white !important;
  opacity: 1;
}

.main-left-item:hover {
  color: #ff6500 !important;;
}


.head-left:hover{
  transform: translateY(0.242vw);
}
/*包含以下四种的链接*/
a {
  text-decoration: none;
}

/*正常的未被访问过的链接*/
a:link {
  text-decoration: none;
}

/*已经访问过的链接*/
a:visited {
  text-decoration: none;
}

/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: none;
}

/* 正在点击的链接*/
a:active {
  text-decoration: none;
}

a:link {
  color: #ffffff;
}

a:visited {
  color: #ffffff
}


a:hover {
  color: #ffffff
}

a:active {
  color: #ffffff
}


</style>
